import { on, createReducer, Action } from '@ngrx/store';

import { saveBrighterFederationPartnerDataError } from './chcp-federation.actions';

export const CHCP_FEDERATION_DETAILS_FEATURE_KEY = 'chcpFedertaion';

import { ServiceError } from '@cigna/chcp/shared/util';

export interface ChcpFederationDetails {
  brighterFederationError: ServiceError | null;
}

export interface ChcpFederationPartialState {
  readonly [CHCP_FEDERATION_DETAILS_FEATURE_KEY]: ChcpFederationDetails;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
const updateFullState = (data: any) => ({
  brighterFederationError: null,
});

export const initialState: ChcpFederationDetails = {
  brighterFederationError: null,
};

export const chcpFederationReducer = createReducer(
  initialState,

  on(saveBrighterFederationPartnerDataError, (state, { error }) => ({
    ...state,
    brighterFederationError: error,
  })),
);

export function reducer(
  state: ChcpFederationDetails | undefined,
  action: Action,
) {
  return chcpFederationReducer(state, action);
}
